"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = void 0;
const accounts_js_1 = require("../utils/accounts.js");
const uid_js_1 = require("../utils/uid.js");
function createClient(parameters) {
  var _parameters$pollingIn;
  const {
    batch,
    cacheTime = (_parameters$pollingIn = parameters.pollingInterval) !== null && _parameters$pollingIn !== void 0 ? _parameters$pollingIn : 4000,
    key = 'base',
    name = 'Base Client',
    pollingInterval = 4000,
    type = 'base'
  } = parameters;
  const chain = parameters.chain;
  const account = parameters.account ? (0, accounts_js_1.parseAccount)(parameters.account) : undefined;
  const {
    config,
    request,
    value
  } = parameters.transport({
    chain,
    pollingInterval
  });
  const transport = _objectSpread(_objectSpread({}, config), value);
  const client = {
    account,
    batch,
    cacheTime,
    chain,
    key,
    name,
    pollingInterval,
    request,
    transport,
    type,
    uid: (0, uid_js_1.uid)()
  };
  function extend(base) {
    return extendFn => {
      const extended = extendFn(base);
      for (const key in client) delete extended[key];
      const combined = _objectSpread(_objectSpread({}, base), extended);
      return Object.assign(combined, {
        extend: extend(combined)
      });
    };
  }
  return Object.assign(client, {
    extend: extend(client)
  });
}
exports.createClient = createClient;
//# sourceMappingURL=createClient.js.map